export default {
  // 页面标题
  title: "修改密码",

  // 表单标签
  password: "密码",
  confirmPassword: "确认密码",

  // 按钮
  cancel: "取消",
  modifyPassword: "修改密码",

  // 验证消息
  pleaseEnterPassword: "请输入密码",
  pleaseConfirmPassword: "请再次输入密码",
  passwordMismatch: "两次输入密码不一致!",

  // 成功消息
  modifySuccess: "修改成功",
};
